import React, { createContext, useState } from 'react';

type CollaboratorContextProps = {
	children: React.ReactNode;
};

export const CollaboratorContext = createContext({});

export const CollaboratorProvider = ({
	children,
}: CollaboratorContextProps): JSX.Element => {
	const [filterParam, setFilterParam] = useState<string>('');
	const [branchOffices, setBranchOffices] = useState<any[]>([]);
	const [isLoadingCommunication, setLoadingCommunication] = useState(false);

	return (
		<CollaboratorContext.Provider
			value={{
				filterParam,
				setFilterParam,
				isLoadingCommunication,
				setLoadingCommunication,
				branchOffices,
				setBranchOffices,
			}}
		>
			{children}
		</CollaboratorContext.Provider>
	);
};
